import { MessagePrimitive } from '@assistant-ui/react';

import { MarkdownText } from '../markdown-text/MarkdownText.tsx';
import { Bubble } from '#plugin-chat/components/bubble/Bubble.tsx';
import type { BubbleKind } from '#plugin-chat/components/bubble/bubble-types.ts';

export interface UserBubbleProps {
  kind?: BubbleKind;
}

/**
 * Renders a user message bubble with markdown support.
 * @param kind - Visual variant for the bubble (e.g., error, success)
 */
export function UserBubble({ kind }: UserBubbleProps) {
  return (
    <Bubble kind={kind} role="user">
      <MessagePrimitive.Parts
        components={{
          // Override Text renderer to enable markdown formatting in user input
          Text: MarkdownText,
        }}
      />
    </Bubble>
  );
}
